<header class="fixed-head">
  <div class="header-container">
    @if (notificationBarText()) {
      <app-notification-bar [content]="notificationBarText()"></app-notification-bar>
    }
    <div class="header-megamenu">
      <app-header-megamenu-top></app-header-megamenu-top>
    </div>

    <nav class="navbar navbar-expand-lg" aria-label="Menu principale">
      <div class="row  container-element">
        <div class="col-3">
          <a class="navbar-brand" [routerLink]="['/']">
            <img class="logo" src="assets/new_logo/redion_logo.svg" alt="Redion logo"
              title="Redion" width="190" height="33" />
            </a>
          </div>
          @if (hasMenu && !isAreaRiservataLoginPage()) {
            <div class="col-6">
              <ul class="navbar-nav">
                @for (item of structureLinkMegamenu; track $index) {
                  @if(item.product_title_menu) {
                    <li [class]="['nav-item', item.product_title_menu]"
                      (mouseenter)="openMegamenu(item)"
                      (mouseleave)="closeMegamenu(item)">
                      <button type="button"
                        class="nav-item-trigger d-flex align-items-center"
                        [attr.aria-expanded]="product() === item.product_title_menu"
                        [attr.aria-controls]="'megamenu-panel-' + $index"
                        (keydown)="onMegamenuKeydown($event, item)">
                        <span class="link">{{item.product_title_menu}}</span>
                        <app-icon
                          [name]="item.activeArrow ? 'CaretUp' : 'CaretDown'"
                          [size]="14"
                          aria-hidden="true"
                        />
                      </button>
                      @if(product() === item.product_title_menu) {
                        <div [id]="'megamenu-panel-' + $index" class="megamenu-panel">
                          <app-megamenu [objMegamenu]="item"></app-megamenu>
                        </div>
                      }
                    </li>
                  }
                }
              </ul>
            </div>
            }
        @if (hasUserMenu && !isAreaRiservataLoginPage()) {
          <div class="col-3 align-items-center d-flex" style="padding-right: 0;">
            <div class="clienti-container" [class]="{'accedi' : !user()}">
              <div class="button-profile">
                <a
                  class="header-icon-btn"
                  aria-label="Vai al carrello"
                  [routerLink]="['/funnel/carrello']">
                  @if (user()) {
                    <div class="cart-items" aria-hidden="true">{{cartService.getItems().length}}</div>
                  }
                  <app-icon
                    [name]="'ShoppingCartSimple'"
                    [size]="32"
                    aria-hidden="true"
                  />
                </a>
                <button type="button"
                  class="hello header-profile-btn"
                  [attr.aria-expanded]="showMenuUser()"
                  aria-controls="user-menu-panel"
                  aria-label="Area clienti"
                  (click)="toggleMenuUser()">
                  <app-icon
                    [name]="'User'"
                    [size]="32"
                    aria-hidden="true"
                  />
                  <span class="user-info">
                    @if (user()) {
                      Ciao, {{ user().FirstName || user().Name }}
                    } @else {
                      Accedi
                    }
                  </span>
                </button>
              </div>
              @if (showRegistrationTooltip() && user()) {
                <div class="registration-tooltip-container">
                  <div class="tooltip-box">
                    <h4>Benvenuto {{ user().FirstName || user().Name }}</h4>
                    @if (!showResetPasswordTooltip()) {
                      <p>
                        Clicca qui per accedere alla tua nuova area clienti per
                        modificare i tuoi dati o visualizzare le tue polizze.
                      </p>
                    }
                    @if (showResetPasswordTooltip()) {
                      <p>Per resettare la tua password clicca qui
                        <a [routerLink]="['/area-riservata/tuoi-dati/reset-password']">Reset Password</a>
                      </p>
                    }
                  </div>
                </div>
              }
              @if (showMenuUser()) {
                <div id="user-menu-panel" class="user-container" appFocusTrap (escape)="closeUserMenu()">
                  <button type="button" class="close-login" aria-label="Chiudi menu area clienti" (click)="closeUserMenu()">
                    <app-icon [name]="'X'" [size]="32" aria-hidden="true"></app-icon>
                  </button>
                  <app-login-box [open]="showMenuUser()" (onClose)="onCloseLogin($event)" [hidden]="user()"></app-login-box>
                  @if (user()) {
                    <div class="profile-items">
                      <ul class="list-unstyled menu-items">
                        <li>
                          <a [routerLink]="['/area-riservata','tuoi-prodotti']"
                            [queryParams]="{tab: 'policies'}"
                            routerLinkActive="active"
                            (click)="showMenuUser.set(false)"
                          >I tuoi prodotti</a>
                        </li>
                        <li>
                          <a [routerLink]="['/area-riservata','tuoi-preventivi']"
                            routerLinkActive="active"
                            (click)="showMenuUser.set(false)">I tuoi preventivi</a>
                        </li>
                        <li>
                          <a [routerLink]="['/area-riservata','tuoi-sinistri']"
                            routerLinkActive="active"
                            (click)="showMenuUser.set(false)"
                          >I tuoi sinistri</a>
                        </li>
                        <li>
                          <a [routerLink]="['/area-riservata','tuoi-dati']"
                            routerLinkActive="active"
                            (click)="showMenuUser.set(false)"
                          >I tuoi dati</a>
                        </li>
                      </ul>
                      <ul class="list-unstyled menu-items">
                        @if (user().HasMyClinic) {
                          <li>
                            <a href="https://myclinic.redion.it/#/landing" target="_blank" rel="noopener noreferrer">
                              Myclinic
                              <span class="sr-only">(si apre in nuova finestra)</span>
                            </a>
                          </li>
                        }
                        <li>
                          <button type="button" class="logout-btn" (click)="logout()">Disconnetti</button>
                        </li>
                      </ul>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        <!-- Da fixare e rilasciare al prossimo rilascio -->
        @if (backHome) {
          <div class="col-4 d-flex" style="margin-left: auto;">
            <div class="container-area-clienti">
              @if (!user()) {
                <button type="button" class="header-profile-btn area-clienti-btn" aria-label="Area clienti" (click)="toggleMenuUser()">
                  <i class="europe europe-user-outiline" aria-hidden="true"></i>
                  <span class="area-clienti">Area Clienti</span>
                </button>
              }
            </div>
            @if (showMenuUser()) {
              <div id="user-menu-panel-backhome" class="user-container-area" appFocusTrap (escape)="closeUserMenu()">
                <button type="button" class="close-login" aria-label="Chiudi menu area clienti" (click)="closeUserMenu()">
                  <i class="europe europe-close" aria-hidden="true"></i>
                </button>
                <app-login-box [open]="showMenuUser()" (onClose)="onCloseLogin($event)" [hidden]="user()"></app-login-box>
              </div>
            }
            <button type="button" class="btn menu-action" (click)="goBackToHome()">
              TORNA ALLA HOME PAGE
            </button>
          </div>
        }

      </div>
    </nav>
  </div>
</header>
